import "./Lessons.css";

import { RootState, useAppSelector } from "../../../store";
import { useEffect, useState } from "react";

import Header from "../../../components/Header";
import LessonsAudios from "./LessonsAudios";
import LessonsEmbed from "./LessonsEmbed";
import LessonsFileViewer from "./LessonsFileViewer";
import LessonsGames from "./LessonsGames";
import LessonsList from "./LessonsList";
import LessonsMaterial from "./LessonsMaterial";
import ScreenLayoutIcon from "../../../components/custom-icons/ScreenLayoutIcon";
import ThemeIcon from "../../../components/custom-icons/ThemeIcon";
import { getAudios } from "./Lessons.service";
import { useLoaUser } from "./lessonHooks";

export const Lessons = () => {
  const { loaUser } = useLoaUser();
  const lesson = useAppSelector((state: RootState) => state.lesson.lesson);
  const course = useAppSelector((state: RootState) => state.lesson.course);
  const layout = useAppSelector((state: RootState) => state.lesson.layout);
  const material = useAppSelector((state: RootState) => state.lesson.material);

  const [showSupport, setShowSupport] = useState(layout.support);

  const hasAudio = !!getAudios(course?.slug)?.length;
  const hasGames = !!course?.games.length;
  const hasMaterial = !!course?.material.length;
  const hasSupport = hasAudio || hasGames || hasMaterial;

  useEffect(() => {
    setShowSupport(layout.support && hasSupport);
  }, [layout, hasSupport]);

  if (!loaUser) return null;
  if (!lesson) return null;
  if (!course) return null;

  const title = `${loaUser.name}: ${course.name} / ${lesson.name}`;
  const supportClass = "support active"; // klassi({ active: showSupport }, "support");

  return (
    <div className="loa-page lessons-page">
      <Header>
        <a href="/courses" className="lessons-back">
          My Courses
        </a>
        <h3 className="lessons-title">{title}</h3>
        <div className="lessons-controls">
          <ThemeIcon />
          <ScreenLayoutIcon layout={layout} hasSupport={hasSupport} />
        </div>
      </Header>
      <div className="lesson-content">
        <div className="wrapper">
          <LessonsList user={loaUser} course={course} />
          <div className="fullscreen">
            <LessonsEmbed />
          </div>
        </div>
        {showSupport && (
          <div className={supportClass}>
            {hasMaterial && <LessonsMaterial material={course.material} />}
            {hasAudio && <LessonsAudios slug={course.slug} />}
            {hasGames && <LessonsGames games={course.games} />}
          </div>
        )}
      </div>
      <LessonsFileViewer />
    </div>
  );
};
